import { useEpaperDashboard } from "./useEpaperDashboard";
import { useEpaperUpdates } from "./useEpaperUpdates";

export function useEpaperPage() {
  const dashboard = useEpaperDashboard();
  const updates = useEpaperUpdates({
    editions: dashboard.editions,
    isMultiDayRange: dashboard.isMultiDayRange,
    updateDateApi: dashboard.updateDateApi,
    fetchDashboard: dashboard.fetchDashboard,
    waitForDashboardRefresh: dashboard.waitForDashboardRefresh,
  });

  return { dashboard, updates };
}
